import { IChainId } from '@/interface'
import { ethers } from 'ethers'
import { onMounted, Ref, ref } from 'vue'
import BN from 'bignumber.js'
import redPacketAddress from '@/contract/redPacketAddress'
import { TokenContract } from '@/contract/func/token'

export function getProvider () {
  return new ethers.providers.Web3Provider(window.ethereum as any)
}

/**
 * 连接钱包
 * @param tokenAddress 币种地址
 * @returns
 */
export async function connectWallet (tokenAddress?: string) {
  const provider = getProvider()

  const [account, ethChainId] = await Promise.all([
    provider.send('eth_requestAccounts', []),
    provider.send('eth_chainId', [])
  ])

  // 地址区分大小写
  const address = ethers.utils.getAddress(account[0])

  const chainId = new BN(ethChainId).toNumber() as IChainId

  console.log('chainId', chainId)

  const redPackContractAddr = redPacketAddress[chainId]

  let balance

  // if (tokenAddress) {
  //   const tokenContract = new TokenContract(provider.getSigner(), tokenAddress)

  //   const getBalance = await tokenContract.balanceOf(address)

  //   balance = getBalance.toString()
  // } else {
  //   const getBalance = await provider.getSigner().getBalance()

  //   balance = getBalance.toString()
  // }

  // console.log('balance', balance.toString())

  return {
    address, redPackContractAddr, balance, chainId
  }
}

export function getChainId (tokenAddress?: string) {
  const provider = new ethers.providers.Web3Provider(window.ethereum as any)

  const chainId = ref() as Ref<IChainId>

  const balance = ref()

  const redPackContractAddr = ref('')

  onMounted(async () => {
    const ethChainId = await provider.send('eth_chainId', [])

    chainId.value = new BN(ethChainId).toNumber() as IChainId

    redPackContractAddr.value = redPacketAddress[chainId.value]

    if (tokenAddress) {
      const getBalance = await provider.getBalance(tokenAddress)

      balance.value = getBalance.toString()
    }
  })

  return {
    chainId,
    provider,
    balance,
    redPackContractAddr
  }
}
